import axios, { AxiosHeaders } from 'axios';
import { getApiAuthToken, signOutUser } from '../../firebaseAuth';

const baseURL = process.env.REACT_APP_API_ENDPOINT || '/api';

export const http = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 15000,
});

async function fetchIdToken(forceRefresh = false) {
  try {
    return await getApiAuthToken(forceRefresh);
  } catch {
    return null;
  }
}

http.interceptors.request.use(async (config) => {
  const token = await fetchIdToken();
  if (token) {
    const headers = AxiosHeaders.from(config.headers);
    headers.set('Authorization', `Bearer ${token}`);
    headers.set('X-Client', 'flotte-web');
    headers.set('X-Request-At', new Date().toISOString());
    config.headers = headers;
  }
  return config;
});

http.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error?.config || {};
    const status = error?.response?.status ?? 0;

    if (status === 401 && !original._retry) {
      original._retry = true;
      try {
        const fresh = await fetchIdToken(true);
        if (fresh) {
          const headers = AxiosHeaders.from(original.headers);
          headers.set('Authorization', `Bearer ${fresh}`);
          original.headers = headers;
          return http(original);
        }
      } catch {
        // ignore
      }
      try {
        await signOutUser();
      } catch {
        // ignore
      }
    }

    const message =
      error?.response?.data?.message ??
      error?.message ??
      'Network/Server error';

    return Promise.reject(Object.assign(error, { status, message }));
  }
);
